module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fitbit-sleep-graph"
    }
  }, [_c('mu-paper', [(!_vm.isLoading && _vm.fitbitData.sleep.length > 0) ? _c('fitbit-sleep-chart', {
    attrs: {
      "chart-data": _vm.data,
      "options": _vm.options
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.fitbitData.sleep.length === 0) ? _c('mu-card-text', [_c('alert', {
    attrs: {
      "type": "info",
      "icon": "info"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          Not enough data to create a chart\n        ")])])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfabd5fa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Graphs/Sleep/FitbitSteppedChart.vue
// module id = 3836
// module chunks = 1